<template>
  <div>
    <div v-if="showFinance" class="styleRow">
      <graph-container></graph-container>
      <notifications></notifications>
      <finance-graph
        :query-object="queryObject"
        :range-payment-method-data="rangePaymentMethodData"
        @ALLData="fillIt"
      ></finance-graph>
    </div>
    <div>
      <div class="main-finance-container">
        <div v-if="!showFinance">
          <confirm-password
            @enterPersonalTab="showFinance = !showFinance"
          ></confirm-password>
        </div>
      </div>
      <div v-if="showFinance">
        <div v-if="newRow" class="new-row">
          <div
            v-if="newRow"
            id="newPurchase"
            aria-hidden="true"
            aria-labelledby="addPurchaseModal"
            class="modal fade"
            data-backdrop="false"
            role="dialog"
            tabindex="-1"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div
                  class="modal-header"
                  style="display: flex; padding: 5px 15px;"
                >
                  <h5 id="addPurchaseModal" class="modal-title">
                    Add New Purchase
                  </h5>
                  <button
                    aria-label="Close"
                    class="close"
                    data-dismiss="modal"
                    style="margin-left: auto"
                    type="button"
                  >
                    <span aria-hidden="true" @click="cancelAddRow()"
                      >&times;</span
                    >
                  </button>
                </div>
                <div class="modal-body" style="display: flex">
                  <div class="col-md-4">
                    <form>
                      <div class="form-group">
                        <label>Projects</label>
                        <div class="form-group">
                          <finance-tags
                            :path="'projects'"
                            @tagsAdded="handleTags"
                          ></finance-tags>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="user">
                          Users
                          <select
                            id="user"
                            v-model="user_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="user in users"
                              :key="user.id"
                              :value="user.id"
                            >
                              {{ user.name }}
                            </option>
                          </select>
                        </label>
                      </div>

                      <div
                        class="form-group"
                        style="display: flex"
                        v-if="showTaxPercent || newFinance.category_id === 1"
                      >
                        <label for="categories" style="width: 70%">
                          Categories
                          <select
                            v-if="categories.length > 0"
                            id="categories"
                            v-model="newFinance.category_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="category in categories"
                              :key="category.id"
                              :value="category.id"
                            >
                              {{ category.name }}
                            </option>
                          </select>
                        </label>
                        <label style="padding-left: 3px; width: 30%">
                          % of tax
                          <input
                            type="number"
                            class="form-control"
                            v-model="newFinance.taxPercent"
                          />
                        </label>
                      </div>

                      <div class="form-group" v-if="!showTaxPercent">
                        <label for="categories">
                          Categories
                          <select
                            v-if="categories.length > 0"
                            id="categories"
                            v-model="newFinance.category_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="category in categories"
                              :key="category.id"
                              :value="category.id"
                            >
                              {{ category.name }}
                            </option>
                          </select>
                        </label>
                      </div>

                      <div class="form-group">
                        <label>Types</label>
                        <finance-tags
                          :path="'types'"
                          @tagsAdded="handleTags"
                        ></finance-tags>
                      </div>
                      <div class="form-group">
                        <label>Reasons</label>
                        <div class="form-group">
                          <finance-tags
                            :path="'reasons'"
                            @tagsAdded="handleTags"
                          ></finance-tags>
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Details</label>
                        <finance-tags
                          :path="'details'"
                          @tagsAdded="handleTags"
                        ></finance-tags>
                      </div>
                      <div class="form-group">
                        <label for="status">
                          Status
                          <select
                            id="status"
                            v-model="newFinance.status_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-if="status.id < 4"
                              v-for="status in statuses"
                              :key="status.id"
                              :value="status.id"
                            >
                              {{ status.status }}
                            </option>
                          </select>
                        </label>
                      </div>
                      <div class="form-group" style="display: flex">
                        <label for="amount">
                          Amount
                          <input
                            id="amount"
                            v-model="newFinance.amount"
                            class="form-control"
                            step="any"
                            type="number"
                          />
                        </label>

                        <label
                          for="currency"
                          style="margin-left: 3px; width: 40%;"
                        >
                          Currency
                          <select
                            id="currency"
                            v-model="newFinance.currency_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="currency in currency_types"
                              :key="currency.id"
                              :value="currency.id"
                            >
                              {{ currency.symbol }}{{ currency.name }}
                            </option>
                          </select>
                        </label>
                        <label v-if="showVatCheckBox" for="with_vat">
                          vat
                          <input
                            id="with_vat"
                            v-model="newFinance.with_vat"
                            class="form-control"
                            name="vat_checkbox"
                            type="checkbox"
                          />
                        </label>
                      </div>
                      <div class="form-group">
                        <label for="purchase_date">
                          Purchase Date
                          <input
                            id="purchase_date"
                            :max="getMaxDate"
                            :value="newFinance.purchase_date"
                            class="form-control"
                            type="datetime-local"
                            @change="handlePDate"
                          />
                        </label>
                      </div>
                      <div class="form-group" style="display: flex">
                        <label for="purchase_method">
                          Method
                          <select
                            id="purchase_method"
                            v-model="newFinance.purchase_method"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="method in payment_methods"
                              :key="method.id"
                              :value="method.method"
                            >
                              {{ method.method }}
                            </option>
                          </select>
                        </label>

                        <label
                          style="margin-left: 3px"
                          v-if="newFinance.purchase_method !== 'Credit Card '"
                        >
                          Reference ID
                          <input
                            id="ref_id"
                            v-model="newFinance.ref_id"
                            :maxlength="
                              newFinance.purchase_method === 'Credit Card '
                                ? 4
                                : 50
                            "
                            class="form-control"
                            name="ref_id"
                            type="text"
                          />
                        </label>

                        <label
                          style="margin-left: 3px; width: 33%"
                          v-if="newFinance.purchase_method === 'Credit Card '"
                        >
                          4 digits
                          <select
                            v-model="newFinance.ref_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="cc in cc_list"
                              :key="cc.id"
                              :value="cc.last_4_digits"
                            >
                              {{ cc.last_4_digits }}
                            </option>
                          </select>
                        </label>

                        <label
                          v-if="
                            newFinance.purchase_method === 'Credit Card ' ||
                              newFinance.purchase_method === 'Credit Card'
                          "
                          style="margin-left: 3px; width: 33%"
                        >
                          P.Amount
                          <input
                            id="payments_amount"
                            v-model="newFinance.payments_period"
                            class="form-control"
                            name="payments_amount"
                            type="text"
                          />
                        </label>
                      </div>

                      <div class="form-group" style="display: flex">
                        <label for="invoice_date" style="max-width: 44%;">
                          Invoice Date
                          <input
                            id="invoice_date"
                            v-model="newFinance.invoice_date"
                            :max="getMaxDate"
                            class="form-control"
                            type="date"
                          />
                        </label>
                        <label for="due_date" style="margin-left: 3px">
                          Due Date
                          <input
                            id="due_date"
                            v-model="newFinance.due_date"
                            :max="getMaxDate"
                            class="form-control"
                            type="date"
                          />
                        </label>
                      </div>
                      <div class="form-group">
                        <label for="invoice_number">
                          Invoice Number
                          <input
                            id="invoice_number"
                            v-model="newFinance.invoice_number"
                            class="form-control"
                            name="invoice_number"
                            type="text"
                          />
                        </label>
                        <small
                          class="help-block"
                          v-if="invoiceNumberExists"
                          style="color: red"
                          >This Invoice number already exists</small
                        >
                      </div>
                    </form>
                  </div>
                  <div class="col-md-6" style="width: 70%">
                    <span
                      v-if="fileReceived"
                      style="float: left;cursor: pointer;color: red;"
                      title="remove attachment"
                      @click="removeFile()"
                      >x</span
                    >
                    <div v-if="mediaIsImage">
                      <img
                        :src="newFinance.attachment"
                        alt=""
                        height="800px"
                        width="600px"
                      />
                    </div>
                    <div v-if="mediaIsFile">
                      <iframe
                        :src="
                          'https://docs.google.com/viewer?url=' +
                            newFinance.attachment +
                            '&embedded=true'
                        "
                        height="800px"
                        width="600px"
                      ></iframe>
                    </div>
                    <div v-if="!fileReceived" class="form-group files">
                      <input
                        class="form-control-file"
                        style="opacity: 0;"
                        title=""
                        type="file"
                        @change="uploadFile()"
                      />
                    </div>
                  </div>
                </div>
                <div class="modal-footer" style="border-top: none">
                  <button
                    v-if="newRow"
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #100f11;color: white; font-size: 11px"
                    @click.prevent="cancelAddRow()"
                  >
                    CANCEL
                  </button>
                  <button
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #2ea591; color: white; font-size: 11px"
                    @click="saveNewFinance()"
                  >
                    SAVE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Credit card list-->
        <div v-if="creditCardList && !newRow" class="new-row">
          <div
            v-if="creditCardList"
            id="creditCardList"
            aria-hidden="true"
            aria-labelledby="showCreditCardModal"
            class="modal fade"
            data-backdrop="false"
            role="dialog"
            tabindex="-1"
          >
            <div class="modal-dialog" role="document" style="width: 800px">
              <div class="modal-content">
                <div
                  class="modal-header"
                  style="display: flex; padding: 5px 15px;"
                >
                  <h5 id="showCreditCardModal" class="modal-title">
                    Credit card list
                  </h5>
                  <button
                    aria-label="Close"
                    class="close"
                    data-dismiss="modal"
                    style="margin-left: auto"
                    type="button"
                  >
                    <span aria-hidden="true" @click="closeCreditCardListModel()"
                      >&times;</span
                    >
                  </button>
                </div>
                <div class="modal-body" style="">
                  <div class="col-md-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Type</th>
                          <th>Bank</th>
                          <th>Provider</th>
                          <th>Credit Line</th>
                          <th>Last 4 digits</th>
                          <th>Due Date</th>
                          <th>Edit</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(card, i) in cc_list"
                          v-show="editCcId === null"
                          :key="card.id"
                        >
                          <td style="text-align: center;">{{ i + 1 }}</td>
                          <td style="text-align: center;">{{ card.type }}</td>
                          <td style="text-align: center;">{{ card.bank }}</td>
                          <td style="text-align: center;">
                            {{ card.provider }}
                          </td>
                          <td style="text-align: center;">
                            {{ card.credit_line }}
                          </td>
                          <td style="text-align: center;">
                            {{ card.last_4_digits }}
                          </td>
                          <td style="text-align: center;">
                            {{
                              card.due_date === null
                                ? "NOT SET"
                                : formatDate(card.due_date, false)
                            }}
                          </td>
                          <td>
                            <div style="display: flex; margin-left: 6px;">
                              <button
                                class="btn btn-sm btn-danger color-me-red"
                                @click="deleteCreditCard(card.id, false)"
                              >
                                <span
                                  ><i
                                    aria-hidden="true"
                                    class="far fa-trash-alt"
                                  ></i
                                ></span>
                              </button>

                              <button
                                class="btn btn-sm btn-warning color-me-orange"
                                title="editing credit card"
                                @click="editCreditCard(card)"
                              >
                                <span
                                  ><i aria-hidden="true" class="fas fa-edit"></i
                                ></span>
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="editCcId !== null">
                          <td style="text-align: center;">{{ ccToEdit.id }}</td>
                          <td style="text-align: center;">
                            {{ ccToEdit.user_id }}
                          </td>
                          <td style="text-align: center;">
                            {{ ccToEdit.type }}
                          </td>
                          <td style="text-align: center;">
                            {{ ccToEdit.bank }}
                          </td>
                          <td style="text-align: center;">
                            {{ ccToEdit.provider }}
                          </td>
                          <td style="text-align: center;">
                            {{ ccToEdit.credit_line }}
                          </td>
                          <td style="text-align: center;">
                            {{ ccToEdit.last_4_digits }}
                          </td>

                          <td style="text-align: center;">
                            {{ ccToEdit.due_date }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="modal-footer" style="border-top: none">
                  <button
                    v-if="creditCardList"
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #100f11;color: white; font-size: 11px"
                    @click.prevent="closeCreditCardListModel()"
                  >
                    CLOSE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!---A new credit card section-->
        <div v-if="addNewCreditCard && !newRow" class="new-row">
          <div
            v-if="addNewCreditCard"
            id="newCc"
            aria-hidden="true"
            aria-labelledby="addNewCreditCardModal"
            class="modal fade"
            data-backdrop="false"
            role="dialog"
            tabindex="-1"
          >
            <div class="modal-dialog" role="document" style="width: 400px">
              <div class="modal-content">
                <div
                  class="modal-header"
                  style="display: flex; padding: 5px 15px;"
                >
                  <h5 id="addNewCreditCardModal" class="modal-title">
                    Add New Credit Card
                  </h5>
                  <button
                    aria-label="Close"
                    class="close"
                    data-dismiss="modal"
                    style="margin-left: auto"
                    type="button"
                  >
                    <span aria-hidden="true" @click="cancelAddCc()"
                      >&times;</span
                    >
                  </button>
                </div>
                <div class="modal-body" style="display: flex; margin-top: 3px">
                  <div class="col-md-12">
                    <form>
                      <div class="form-group">
                        <label for="cc_user">
                          Users
                          <select
                            id="cc_user"
                            v-model="newCreditCard.user_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="user in users"
                              :key="user.id"
                              :value="user.id"
                            >
                              {{ user.name }}
                            </option>
                          </select>
                        </label>
                      </div>
                      <div class="form-group">
                        <label for="categories">
                          Type
                          <select
                            id="ccType"
                            v-model="newCreditCard.type"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="type in cc_types"
                              :key="type.id"
                              :value="type.type"
                            >
                              {{ type.type }}
                            </option>
                          </select>
                        </label>
                      </div>

                      <div class="form-group">
                        <label for="categories">
                          CC Provider
                          <select
                            v-if="cc_providers.length > 0"
                            id="ccProvider"
                            v-model="newCreditCard.provider"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="provider in cc_providers"
                              :key="provider.id"
                              :value="provider.name"
                            >
                              {{ provider.name }}
                            </option>
                          </select>
                        </label>
                      </div>
                      <div class="form-group">
                        <label for="bank">
                          Bank
                          <select
                            v-if="banks.length > 0"
                            id="bank"
                            v-model="newCreditCard.bank"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="bank in banks"
                              :key="bank.id"
                              :value="bank.name"
                            >
                              {{ bank.name }}
                            </option>
                          </select>
                        </label>
                      </div>
                      <div class="form-group">
                        <label for="last_4_digits">
                          Last 4 digits
                          <input
                            id="last_4_digits"
                            v-model="newCreditCard.last_4_digits"
                            class="form-control"
                            maxlength="4"
                            name="last_4_digits"
                            type="text"
                          />
                        </label>
                      </div>

                      <div class="form-group">
                        <label for="purchase_date">
                          Due Date
                          <input
                            id="cc_due_date"
                            :max="getMaxDate"
                            :value="newCreditCard.due_date"
                            class="form-control"
                            type="date"
                            @change="handleDueDate"
                          />
                        </label>
                      </div>

                      <div class="form-group">
                        <label for="credit_line">
                          Credit Line
                          <input
                            id="credit_line"
                            v-model="newCreditCard.credit_line"
                            class="form-control"
                            name="credit_line"
                            type="number"
                          />
                        </label>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="modal-footer" style="border-top: none">
                  <button
                    v-if="addNewCreditCard"
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #100f11;color: white; font-size: 11px"
                    @click.prevent="cancelAddCc()"
                  >
                    CANCEL
                  </button>
                  <button
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #2ea591; color: white; font-size: 11px"
                    @click="saveNewCreditCard()"
                  >
                    SAVE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Edit section-->
        <div v-if="editMode" class="new-row">
          <div
            v-if="editMode"
            id="editFinance"
            aria-hidden="true"
            aria-labelledby="editPurchaseModal"
            class="modal fade"
            data-backdrop="false"
            role="dialog"
            tabindex="-1"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div
                  class="modal-header"
                  style="display: flex; padding: 5px 15px;"
                >
                  <h5 id="editPurchaseModal" class="modal-title">
                    Edit Purchase
                  </h5>
                  <button
                    aria-label="Close"
                    class="close"
                    data-dismiss="modal"
                    style="margin-left: auto"
                    type="button"
                  >
                    <span aria-hidden="true" @click="cancelEditRow()"
                      >&times;</span
                    >
                  </button>
                </div>
                <div class="modal-body" style="display: flex">
                  <div class="col-md-4">
                    <form>
                      <div class="form-group">
                        <label>Projects</label>
                        <finance-tags
                          :edit-mode="editMode"
                          :initial="setInitialTags('projects')"
                          :path="'projects'"
                          @tagsAdded="handleTags"
                          @tagsEdit="updateTags"
                        ></finance-tags>
                      </div>
                      <div class="form-group">
                        <label for="user">
                          Users
                          <select
                            id="edit_user"
                            v-model="editFinance.user_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="user in users"
                              :key="user.id"
                              :value="user.id"
                            >
                              {{ user.name }}
                            </option>
                          </select>
                        </label>
                      </div>

                      <div
                        class="form-group"
                        style="display: flex"
                        v-if="
                          editFinance.withholding_tax !== null ||
                            (editFinance.category_id === 1 ||
                              editFinance.category_id === 7)
                        "
                      >
                        <label for="categories" style="width: 70%">
                          Categories
                          <select
                            id="edit_categories"
                            v-model="editFinance.category_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="category in categories"
                              :key="category.id"
                              :value="category.id"
                            >
                              {{ category.name }}
                            </option>
                          </select>
                        </label>

                        <label style="width: 30%; padding-left: 3px">
                          % of tax
                          <input
                            type="number"
                            class="form-control"
                            v-model="editFinance.taxPercent"
                          />
                        </label>
                      </div>

                      <div
                        class="form-group"
                        v-if="
                          editFinance.withholding_tax === null ||
                            (editFinance.category_id !== 1 &&
                              editFinance.category_id !== 7)
                        "
                      >
                        <label for="categories">
                          Categories
                          <select
                            id="edit_categories"
                            v-model="editFinance.category_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="category in categories"
                              :key="category.id"
                              :value="category.id"
                            >
                              {{ category.name }}
                            </option>
                          </select>
                        </label>
                      </div>

                      <div class="form-group">
                        <label>Types</label>
                        <finance-tags
                          :edit-mode="editMode"
                          :initial="setInitialTags('types')"
                          :path="'types'"
                          @tagsAdded="handleTags"
                          @tagsEdit="updateTags"
                        ></finance-tags>
                      </div>
                      <div class="form-group">
                        <label>Reasons</label>
                        <div class="form-group">
                          <finance-tags
                            :edit-mode="editMode"
                            :initial="setInitialTags('reasons')"
                            :path="'reasons'"
                            @tagsAdded="handleTags"
                            @tagsEdit="updateTags"
                          ></finance-tags>
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Details</label>
                        <finance-tags
                          :edit-mode="editMode"
                          :initial="setInitialTags('details')"
                          :path="'details'"
                          @tagsAdded="handleTags"
                          @tagsEdit="updateTags"
                        ></finance-tags>
                      </div>

                      <div class="form-group">
                        <label for="edit_status">
                          Status
                          <select
                            id="edit_status"
                            v-model="editFinance.status_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-if="status.id < 4"
                              v-for="status in statuses"
                              :key="status.id"
                              :value="status.id"
                            >
                              {{ status.status }}
                            </option>
                          </select>
                        </label>
                      </div>
                      <div class="form-group" style="display: flex">
                        <label for="amount">
                          Payments
                          <input
                            id="edit_amount"
                            v-model="editFinance.amount"
                            class="form-control"
                            step="any"
                            type="number"
                          />
                        </label>
                        <label
                          for="currency"
                          style="margin-left: 3px; width: 40%;"
                        >
                          Currency
                          <select
                            id="edit_currency"
                            v-model="editFinance.currency_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="currency in currency_types"
                              :key="currency.id"
                              :value="currency.id"
                            >
                              {{ currency.symbol }}{{ currency.name }}
                            </option>
                          </select>
                        </label>
                        <label v-if="showEditVatCheckBox" for="edit_with_vat">
                          vat
                          <input
                            id="edit_with_vat"
                            v-model="editWithVat"
                            class="form-control"
                            name="edit_vat_checkbox"
                            type="checkbox"
                          />
                        </label>
                      </div>

                      <div class="form-group">
                        <label for="purchase_date">
                          Purchase Date
                          <input
                            id="edit_purchase_date"
                            :max="getMaxDate"
                            :value="editFinance.purchase_date"
                            class="form-control"
                            type="datetime-local"
                            @change="handleEPDate"
                          />
                        </label>
                      </div>
                      <div class="form-group" style="display: flex">
                        <label for="edit_purchase_method">
                          Method
                          <select
                            id="edit_purchase_method"
                            v-model="editFinance.purchase_method"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="method in payment_methods"
                              :key="method.id"
                              :value="method.method"
                            >
                              {{ method.method }}
                            </option>
                          </select>
                        </label>
                        <label
                          for="edit_ref_id"
                          style="margin-left: 3px;"
                          v-if="
                            editFinance.purchase_method !== 'Credit Card ' &&
                              editFinance.purchase_method !== 'Credit Card'
                          "
                        >
                          Reference ID
                          <input
                            id="edit_ref_id"
                            v-model="editFinance.ref_id"
                            class="form-control"
                            name="ref_id"
                            type="text"
                          />
                        </label>
                        <label
                          style="margin-left: 3px; width: 33%"
                          v-if="
                            editFinance.purchase_method === 'Credit Card ' ||
                              editFinance.purchase_method === 'Credit Card'
                          "
                        >
                          4 digits
                          <select
                            v-model="editFinance.ref_id"
                            class="form-control"
                            style="padding: 0;"
                          >
                            <option
                              v-for="cc in cc_list"
                              :key="cc.id"
                              :value="cc.last_4_digits"
                            >
                              {{ cc.last_4_digits }}
                            </option>
                          </select>
                        </label>

                        <label
                          v-if="
                            editFinance.purchase_method === 'Credit Card ' ||
                              editFinance.purchase_method === 'Credit Card'
                          "
                          style="margin-left: 3px"
                        >
                          P. Amounts
                          <input
                            id="edit_payments_amount"
                            v-model="editFinance.payments_period"
                            class="form-control"
                            name="edit_payments_amount"
                            type="text"
                          />
                        </label>
                      </div>

                      <div class="form-group" style="display: flex">
                        <label for="invoice_date" style="max-width: 44%">
                          Invoice Date
                          <input
                            id="edit_invoice_date"
                            :max="getMaxDate"
                            :value="editFinance.invoice_date"
                            class="form-control"
                            type="date"
                            @change="handleEPDate"
                          />
                        </label>
                        <label for="edit_due_date" style="margin-left: 3px;">
                          Due Date
                          <input
                            id="edit_due_date"
                            :max="getMaxDate"
                            :value="editFinance.due_date"
                            class="form-control"
                            type="date"
                            @change="handleEDDate"
                          />
                        </label>
                      </div>
                      <div class="form-group">
                        <label for="invoice_number">
                          Invoice Number
                          <input
                            id="edit_invoice_number"
                            v-model="editFinance.invoice_number"
                            class="form-control"
                            name="invoice_number"
                            type="text"
                          />
                        </label>
                      </div>
                    </form>
                  </div>
                  <div class="col-md-6" style="width: 70%">
                    <span
                      v-if="editFinance.attachment !== ''"
                      style="float: left;cursor: pointer;color: red;"
                      title="remove attachment"
                      @click="removeFileFromEdit()"
                      >x</span
                    >
                    <div
                      v-if="
                        checkFileType() === 'image' &&
                          editFinance.attachment !== ''
                      "
                    >
                      <img
                        v-if="mediaIsImage"
                        :src="editFinance.attachment"
                        height="800px"
                        width="600px"
                      />
                    </div>
                    <div
                      v-if="
                        checkFileType() === 'file' &&
                          editFinance.attachment !== ''
                      "
                    >
                      <iframe
                        v-if="mediaIsFile"
                        :src="
                          'https://docs.google.com/viewer?url=' +
                            editFinance.attachment +
                            '&embedded=true'
                        "
                        height="800px"
                        width="600px"
                      ></iframe>
                    </div>
                    <div
                      v-if="editFinance.attachment === ''"
                      class="form-group files"
                    >
                      <input
                        class="form-control-file"
                        style="opacity: 0;"
                        title=""
                        type="file"
                        @change="uploadFile()"
                      />
                    </div>
                  </div>
                </div>

                <div class="modal-footer" style="border-top: none">
                  <button
                    class="btn btn-sm btn-danger color-me-red"
                    @click="deleteRow(editFinance.id, false)"
                  >
                    <span
                      ><i aria-hidden="true" class="far fa-trash-alt"></i
                    ></span>
                  </button>
                  <button
                    v-if="editMode"
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #100f11;color: white; font-size: 11px"
                    @click="cancelEditRow()"
                  >
                    CANCEL
                  </button>
                  <button
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #2ea591; color: white; font-size: 11px"
                    @click="updateFinance(editFinance.id)"
                  >
                    UPDATE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="table" class="table-editable table-condensed">
          <div
            style="display: flex; flex-direction: row-reverse; align-items: flex-end"
          >
            <button
              v-if="!newRow"
              class="btn btn-success"
              data-target="#newPurchase"
              data-toggle="modal"
              @click.prevent="addRow()"
            >
              ADD
              <span><i aria-hidden="true" class="fas fa-plus"></i></span>
            </button>
          </div>
          <div style="display: flex; align-items: flex-start; margin-left: 5px">
            <button
              class="btn btn-sm"
              data-target="#newCc"
              data-toggle="modal"
              title="add new credit card"
              @click.prevent="addNewCC()"
            >
              <span><i class="fas fa-cog"></i></span>
            </button>
            <button
              class="btn btn-sm"
              data-target="#creditCardList"
              data-toggle="modal"
              title="credit card list"
              @click.prevent="showCreditCardList()"
            >
              <span><i class="fas fa-credit-card"></i></span>
            </button>
          </div>

          <div style="margin-top: 5px">
            <tr style="display: flex; justify-content: flex-start;">
              <th style="margin-left: 10px;">
                <i
                  v-show="Object.keys(queryObject).length > 1"
                  class="fas fa-sync"
                  style="cursor: pointer;"
                  title="Reset"
                  @click="resetTable"
                ></i>
              </th>
            </tr>
          </div>

          <table
            class="table table-responsive table-striped table-condensed"
            style="margin-top: 10px"
          >
            <thead>
              <tr>
                <th>
                  <label>
                    <input v-model="selectAll" type="checkbox" />
                  </label>
                </th>
                <th>Edit</th>
                <th>Id</th>
                <th>
                  <input
                    v-model="searchFilterByProject"
                    class="input-filter-user-name"
                    placeholder="Projects"
                    type="search"
                  />
                  <span
                    v-if="projectFilterActive()"
                    class="reset-single-filter"
                    @click="removeProjectFilter()"
                    >x</span
                  >
                </th>
                <th style="text-align: center;">
                  <div
                    style="display: flex; align-items: center; justify-content: center;"
                  >
                    <input
                      v-model="filterByUserName"
                      class="input-filter-user-name"
                      placeholder="U.name"
                      type="search"
                    />
                    <span style="font-size: 10px; margin-left: 2px">
                      | {{ totalUsers }}</span
                    >
                  </div>
                </th>
                <th>
                  <multi-select
                    :background="{
                      mainBg: 'background: white;',
                      btnBg: 'background-color: black; border-color: none;',
                      color: 'black'
                    }"
                    @finance_categories="msCategories"
                    :expandToRight="true"
                    :query-object="queryObject"
                    :sector="'finance_total'"
                    :selected-main-tab="'finance'"
                  ></multi-select>
                </th>
                <th>
                  <input
                    v-model="searchFilterByType"
                    class="input-filter-user-name"
                    placeholder="Types"
                    type="search"
                  />
                  <span
                    v-if="typeFilterActive()"
                    class="reset-single-filter"
                    @click="removeTypeFilter()"
                    >x</span
                  >
                </th>
                <th>
                  <input
                    v-model="searchFilterByReason"
                    class="input-filter-user-name"
                    placeholder="Reason"
                    type="search"
                  />
                  <span
                    v-if="reasonFilterActive()"
                    class="reset-single-filter"
                    @click="removeReasonFilter()"
                    >x</span
                  >
                </th>
                <th>
                  <input
                    v-model="searchFilterByDetail"
                    class="input-filter-user-name"
                    placeholder="Details"
                    type="search"
                  />
                  <span
                    v-if="detailsFilterActive()"
                    class="reset-single-filter"
                    @click="removeDetailsFilter()"
                    >x</span
                  >
                </th>
                <th>
                  <div>
                    <div
                      style="display: flex; align-items: center; justify-content: center;"
                    >
                      <input
                        v-model="filterByAmount"
                        class="input-filter-amount"
                        placeholder="Payments"
                        type="text"
                      />

                      <button
                        v-if="!amountSortOrder"
                        class="btn btn-default btn-sm override"
                        @click="sortByAmount()"
                      >
                        <span class="fas fa-sort-amount-up"></span>
                      </button>
                      <button
                        v-if="amountSortOrder"
                        class="btn btn-default btn-sm override"
                        @click="sortByAmountAsc()"
                      >
                        <span class="fas fa-sort-amount-down"></span>
                      </button>
                      <span style="font-size: 10px;">
                        <span style="color: red;">{{
                          kFormatter(totalAmount)
                        }}</span>
                      </span>
                      <span
                        v-if="amountFilterActive()"
                        class="reset-single-filter"
                        @click="removeAmountFilter()"
                        >x</span
                      >
                    </div>
                  </div>
                </th>
                <th>
                  <div
                    style="display: flex; align-items: center; justify-content: center;"
                  >
                    <input
                      v-model="filterByVat"
                      class="input-filter-amount"
                      placeholder="Vat"
                      type="text"
                    />

                    <button
                      v-if="!vatSortOrder"
                      class="btn btn-default btn-sm override"
                      @click="sortByVat()"
                    >
                      <span class="fas fa-sort-amount-up"></span>
                    </button>
                    <button
                      v-if="vatSortOrder"
                      class="btn btn-default btn-sm override"
                      @click="sortByVatAsc()"
                    >
                      <span class="fas fa-sort-amount-down"></span>
                    </button>
                    <span style="font-size: 10px;">
                      <span style="color: red;"
                        >-{{ kFormatter(totalVat) }}</span
                      >
                    </span>
                    <span
                      v-if="vatFilterActive()"
                      class="reset-single-filter"
                      @click="removeVatFilter()"
                      >x</span
                    >
                  </div>
                </th>
                <th>tax</th>
                <th>
                  <multi-select
                    :background="{
                      mainBg: 'background: white;',
                      btnBg: 'background-color: black; border-color: none;',
                      color: 'black'
                    }"
                    @finance_status="msStatus"
                    :expandToRight="false"
                    :query-object="queryObject"
                    :sector="'finance_status'"
                    :selected-main-tab="'finance'"
                  ></multi-select>
                  <span
                    v-if="statusFilterActive()"
                    class="reset-single-filter"
                    @click="removeStatusFilter()"
                    >x</span
                  >
                </th>
                <th>
                  <multi-select
                    :background="{
                      mainBg: 'background: white;',
                      btnBg: 'background-color: black; border-color: none;',
                      color: 'black'
                    }"
                    @finance_currency="msCurrency"
                    :expandToRight="false"
                    :query-object="queryObject"
                    :sector="'finance_currency'"
                    :selected-main-tab="'finance'"
                  ></multi-select>
                  <span
                    v-if="currencyFilterActive()"
                    class="reset-single-filter"
                    @click="removeCurrencyFilter()"
                    >x</span
                  >
                </th>
                <th>
                  <multi-select
                    :background="{
                      mainBg: 'background: white;',
                      btnBg: 'background-color: black; border-color: none;',
                      color: 'black'
                    }"
                    @finance_methods="msMethods"
                    :expandToRight="false"
                    :query-object="queryObject"
                    :sector="'finance_methods'"
                    :selected-main-tab="'finance'"
                  ></multi-select>

                  <span
                    v-if="methodFilterActive()"
                    class="reset-single-filter"
                    @click="removeMethodFilter()"
                    >x</span
                  >
                </th>
                <th>
                  Ref. ID
                  <span
                    v-if="refIdFilterActive()"
                    class="reset-single-filter"
                    @click="removeRefIdFilter()"
                    >x</span
                  >
                </th>
                <th>
                  Purchase Date
                  <span
                    v-if="purchaseDateFilterActive()"
                    class="reset-single-filter"
                    @click="removePurchaseDateFilter()"
                    >x</span
                  >
                </th>
                <th>
                  Inv. date
                  <span
                    v-if="invoiceDateFilterActive()"
                    class="reset-single-filter"
                    @click="removeInvoiceDateFilter()"
                    >x</span
                  >
                </th>

                <th>
                  Due date
                  <span
                    v-if="dueDateFilterActive()"
                    class="reset-single-filter"
                    @click="removeDueDateFilter()"
                    >x</span
                  >
                </th>

                <th>
                  <input
                    v-model="filterByInvoiceNumber"
                    class="input-filter-invoice-number"
                    placeholder="Inv. Number"
                    type="search"
                  />
                  <span
                    v-if="invoiceNumberFilterActive()"
                    class="reset-single-filter"
                    @click="removeInvoiceNumberFilter()"
                    >x</span
                  >
                </th>

                <th>Attachment</th>
                <th>Info</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(finance, index) in financeData" :key="index">
                <td style="text-align: center; font-size: 13px">
                  <label>
                    <input
                      v-model="selectedRows"
                      :value="finance.id"
                      type="checkbox"
                    />
                  </label>
                </td>
                <td>
                  <div style="display: flex; margin-left: 6px;">
                    <button
                      class="btn btn-sm btn-warning color-me-orange"
                      data-target="#editFinance"
                      data-toggle="modal"
                      @click="editRow(finance)"
                    >
                      <span
                        ><i aria-hidden="true" class="fas fa-edit"></i
                      ></span>
                    </button>
                  </div>
                </td>
                <td style="text-align: center; font-size: 13px">
                  {{ finance.id }}
                </td>
                <td style="text-align: center; font-size: 13px">
                  <div>
                    <button
                      v-for="(project, projectIdx) in finance.projects"
                      :key="projectIdx"
                      class="btn btn-warning btn-tag tag-item"
                      @click="filterByProject(project.project)"
                    >
                      {{ project.project }}
                    </button>
                  </div>
                </td>
                <td style="text-align: center;">
                  {{ finance.user.full_name }}
                </td>
                <td style="text-align: center; font-size: 13px">
                  {{ finance.category.name }}
                </td>
                <td style="text-align: center; font-size: 13px">
                  <div>
                    <button
                      v-for="(type, typeIdx) in finance.types"
                      :key="typeIdx"
                      class="btn btn-warning btn-tag tag-item"
                      @click="filterByType(type.type)"
                    >
                      {{ type.type }}
                    </button>
                  </div>
                </td>
                <td style="text-align: center; font-size: 13px">
                  <div>
                    <button
                      v-for="(reason, reasonIdx) in finance.reasons"
                      :key="reasonIdx"
                      class="btn btn-warning btn-tag tag-item"
                      @click="filterByReason(reason.reason)"
                    >
                      {{ reason.reason }}
                    </button>
                  </div>
                </td>
                <td style="text-align: center; font-size: 13px">
                  <div v-if="finance.details.length > 0">
                    <button
                      v-for="(detail, detailIdx) in finance.details"
                      :key="detailIdx"
                      class="btn btn-warning btn-tag tag-item"
                      @click="filterByDetails(detail.detail)"
                    >
                      {{ detail.detail }}
                    </button>
                  </div>

                  <span v-if="finance.details.length === 0">{{
                    finance.purchase_details
                  }}</span>
                </td>

                <td
                  v-if="
                    finance.purchase_method !== 'Deductible' &&
                      finance.category.id !== 12
                  "
                  style="text-align: center; color: red; font-size: 13px"
                >
                  <span v-if="finance.purchase_method !== 'Credit Card'">
                    -{{
                      new Intl.NumberFormat("he-IL", {}).format(
                        finance.ils_amount
                      )
                    }}₪</span
                  >
                  <span
                    v-if="
                      finance.purchase_method === 'Credit Card' &&
                        finance.payments_period === null
                    "
                  >
                    -{{
                      new Intl.NumberFormat("he-IL", {}).format(
                        finance.ils_amount
                      )
                    }}₪
                  </span>
                  <span
                    v-if="
                      finance.purchase_method === 'Credit Card' &&
                        finance.payments_period !== null
                    "
                  >
                    <span>-{{ checkForPayments(finance) }}</span>
                    (-{{
                      new Intl.NumberFormat("he-IL", {}).format(
                        finance.ils_amount
                      )
                    }}₪) <span>1/{{ finance.payments_period }}</span>
                  </span>
                  <span v-if="finance.currency_id !== 4" style="font-size: 10px"
                    >({{ displayOriginalAmount(finance) }})</span
                  >
                </td>

                <td
                  v-if="finance.purchase_method === 'Deductible'"
                  style="text-align: center; color: #5bc0de; font-size: 13px"
                >
                  -{{
                    new Intl.NumberFormat("he-IL", {}).format(
                      finance.ils_amount
                    )
                  }}₪
                  <span v-if="finance.currency_id !== 4" style="font-size: 10px"
                    >({{ displayOriginalAmount(finance) }})</span
                  >
                </td>

                <td
                  v-if="finance.category.id === 12 && finance.status_id !== 5"
                  style="text-align: center; color: #5bc0de; font-size: 13px"
                >
                  <span>
                    +{{
                      new Intl.NumberFormat("he-IL", {}).format(
                        finance.ils_amount
                      )
                    }}₪</span
                  >
                </td>
                <td
                  v-if="finance.category.id === 12 && finance.status_id === 5"
                  style="text-align: center; color: red; font-size: 13px"
                >
                  <span
                    >-{{
                      new Intl.NumberFormat("he-IL", {}).format(
                        finance.ils_amount
                      )
                    }}₪</span
                  >
                </td>

                <td style="text-align: center; font-size: 13px">
                  {{ calcVatPayments(finance) }}
                </td>
                <td style="text-align: center; color: red; font-size: 13px">
                  -{{ finance.withholding_tax }}
                </td>
                <td style="text-align: center; font-size: 13px">
                  <button
                    class="btn btn-tag tag-item"
                    @click="filterByStatus(finance.status.status)"
                  >
                    {{ finance.status.status }}
                  </button>
                </td>
                <td style="text-align: center; font-size: 13px">
                  <button
                    class="btn btn-success btn-tag tag-item"
                    @click="filterByCurrency(finance.currency_id)"
                  >
                    {{ getCurrency(finance.currency_id) }}
                  </button>
                </td>
                <td style="text-align: center; font-size: 13px">
                  <button
                    class="btn btn-info btn-tag tag-item"
                    @click="filterByPaymentMethod(finance.purchase_method)"
                  >
                    {{
                      finance.purchase_method === "Credit Card"
                        ? "CC"
                        : finance.purchase_method
                    }}
                  </button>
                </td>
                <td style="text-align: center; font-size: 13px">
                  <button
                    class="btn btn-info btn-tag tag-item"
                    @click="filterByLastDigits(finance.ref_id)"
                    @mouseenter="showCCInfo = finance.id"
                    @mouseleave="showCCInfo = null"
                  >
                    {{ finance.ref_id }}
                  </button>
                </td>
                <td style="text-align: center; font-size: 13px">
                  {{
                    finance.purchase_date === null
                      ? "No Date"
                      : formatDate(finance.purchase_date, true)
                  }}
                </td>
                <td style="text-align: center; font-size: 13px">
                  {{
                    finance.invoice_date === null
                      ? "No Date"
                      : formatDate(finance.invoice_date, false)
                  }}
                </td>

                <td style="text-align: center; font-size: 13px">
                  {{
                    finance.due_date === null
                      ? "No Date"
                      : formatDate(finance.due_date, false)
                  }}
                </td>
                <td style="text-align: center;">
                  <span
                    v-if="finance.invoice_number !== null"
                    v-tooltip="{ content: finance.invoice_number }"
                  >
                    {{ finance.invoice_number | truncate(5) }}
                  </span>
                </td>

                <!--Attachment-->
                <td style="text-align: center; font-size: 13px">
                  <span v-if="finance.attachment === ''">--</span>
                  <a
                    v-if="finance.attachment !== ''"
                    :href="finance.attachment"
                    target="_blank"
                    @mouseleave="
                      (popUpId = null) &&
                        (showAttPopup = false) &&
                        (mediaIsImage = false) &&
                        (mediaIsFile = false)
                    "
                    @mouseenter="
                      (popUpId = finance.id) && (showAttPopup = true)
                    "
                    >Attachment</a
                  >
                  <span
                    v-if="showAttPopup"
                    style="position: absolute;top: 200px;right: 695px; z-index: 1; background-color: white; border: 1px solid black"
                  >
                    <div
                      v-if="
                        checkAttachmentType(finance.attachment) === 'file' &&
                          popUpId === finance.id
                      "
                      style="width: 600px; height: 600px;"
                    >
                      <iframe
                        width="600px"
                        height="600px"
                        :src="
                          'https://docs.google.com/viewer?url=' +
                            finance.attachment +
                            '&embedded=true'
                        "
                      ></iframe>
                    </div>
                    <div
                      v-if="
                        checkAttachmentType(finance.attachment) === 'image' &&
                          popUpId === finance.id
                      "
                      style="width: 600px; height: 600px;"
                    >
                      <img
                        :src="finance.attachment"
                        height="600px"
                        width="600px"
                      />
                    </div>
                  </span>
                </td>
                <td style="text-align: center; font-size: 13px">
                  <i
                    class="fas fa-eye eye-count-icon"
                    @mouseenter="creatorInfoPopup = finance.id"
                    @mouseleave="creatorInfoPopup = null"
                  ></i>
                  <span v-if="creatorInfoPopup === finance.id">
                    <div class="log-table-views">
                      <div class="table-responsive">
                        <table class="table" style="margin-bottom: 0">
                          <tbody>
                            <tr>
                              <td>{{ finance.creator.full_name }}</td>
                              <td>
                                {{ formatDate(finance.created_at, true) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </span>
                </td>
                <button
                  v-if="rowSelected(finance.id) && selectedRows.length > 1"
                  class="btn btn-sm btn-danger color-me-red"
                  style="position: absolute; left: 10px; top: 215px;"
                  @click="deleteRow(0, true)"
                >
                  DELETE SELECTED
                  <span
                    ><i aria-hidden="true" class="far fa-trash-alt"></i
                  ></span>
                </button>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th style="border: none">
                  <div class="vertical-scroll-buttons">
                    <button
                      :disabled="pagination.currentPage === 1"
                      class="vertical-scroll-btn-first"
                      type="button"
                      @click="setPage(1)"
                    >
                      <i class="fas fa-angle-double-left"></i>
                    </button>
                    <button
                      :disabled="pagination.currentPage === 1"
                      class="vertical-scroll-btn-second"
                      @click="setPage(pagination.currentPage - 1)"
                    >
                      <span>
                        <i
                          v-if="pagination.currentPage !== 1"
                          class="fas fa-angle-up"
                        ></i>
                      </span>
                      <span>
                        {{ pagination.from }}
                      </span>
                    </button>
                    <button
                      v-if="pagination.total !== 0"
                      :disabled="
                        pagination.lastPage === 1 && pagination.total < 8
                      "
                      aria-expanded="false"
                      class="vertical-scroll-btn-menu"
                      data-toggle="dropdown"
                      @click="paginationDropDownUp = true"
                    >
                      <i class="fas fa-bars"></i>
                    </button>
                    <div
                      :class="{
                        'pagination-vertical-dropdown-down': !paginationDropDownUp
                      }"
                      class="dropdown-menu p-xy-8 pagination-vertical-dropdown"
                    >
                      <div class="listview-pagenum m-xy-0 p-x-8 m-b-4">
                        <span>Page {{ pagination.currentPage }}</span
                        >&nbsp; &nbsp; <span>of</span>&nbsp;
                        <strong
                          ><span id="totalPageCount">{{
                            pagination.lastPage
                          }}</span></strong
                        >
                      </div>
                      <div class="listViewPagingBox">
                        <input
                          v-model="pageNumInput"
                          class="listViewPagingInput p-xy-0"
                          placeholder="Jump To"
                          type="search"
                        />&nbsp;
                        <button
                          id="listViewPagingInputSubmit"
                          :disabled="pageNumInput > pagination.lastPage"
                          type="button"
                          @click="setPage(pageNumInput)"
                        >
                          GO
                        </button>
                      </div>
                    </div>
                    <button
                      :disabled="pagination.currentPage === pagination.lastPage"
                      class="vertical-scroll-btn-third"
                      @click="setPage(pagination.currentPage + 1)"
                    >
                      <span>
                        {{ pagination.to }}
                      </span>

                      <span>
                        <i
                          v-if="pagination.currentPage !== pagination.lastPage"
                          class="fas fa-angle-down"
                        ></i>
                      </span>
                    </button>
                    <button
                      :disabled="
                        pagination.currentPage === pagination.lastPage &&
                          pagination.total
                      "
                      class="vertical-scroll-btn-fourth"
                      @click="setPage(pagination.lastPage)"
                    >
                      <i class="fas fa-angle-double-right"></i>
                    </button>
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
      <div v-if="showFinance">
        <finance-calendar
          :query-object="queryObject"
          @due_date="setDueDate"
          @invoice_date="setInvoiceDate"
          @created_date="setCreatedDate"
          @purchase_date="setDate"
          @resetOneCalendar="clearDates"
          @total_spent_by_date="setTotalSpentDate"
          @payment_method_info="setPaymentMethodsInfo"
        ></finance-calendar>
      </div>
      <div v-if="showFinance" class="styleRow">
        <finance-tag-graph :query-object="queryObject"></finance-tag-graph>
        <div class="tempLikeViki">
          <ChartFinance
            v-if="allDataObj"
            :query-object="queryObject"
            :range-payment-method-data="allDataObj"
          />
        </div>
        <security-cams></security-cams>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import ConfirmPassword from "../../../main/user.main/ConfirmPassword";
import apiClientCreator from "../../../helpers/api/request";
import FinanceModel from "../compoenets/FinanceModel";
import UsersPermissionCheck from "../../../mixins/user/auth/UsersPermissionCheck";
import { mapGetters, mapState } from "vuex";
import FinanceTags from "../compoenets/FinanceTags";
import FinanceCalendar from "../compoenets/FinanceCalendar";
import Notifications from "../../msg_center.feature/containers/Notifications.component";
import FinanceGraph from "../../finance.feature/Graphs/FinanceGraph";
import FinanceTagGraph from "../../finance.feature/Graphs/FinanceTagGraph";
import GraphContainer from "../../company.feature/sub_features.company/graph.sub-feature.company/containers/Graph.container";
// import CommContainer from "../../communications.feature/containers/communications.container";
import SecurityCams from "../../security.feature/containers/SecurityCams.container";
import ChartFinance from "../compoenets/ChartFinance.component";
import MultiSelect from "../../company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/MultiSelect.container";

export default {
  name: "FinanceTable.container",
  components: {
    ConfirmPassword,
    FinanceTags,
    FinanceCalendar,
    Notifications,
    GraphContainer,
    ChartFinance,
    SecurityCams,
    // CommContainer,
    FinanceGraph,
    MultiSelect,
    FinanceTagGraph
  },
  mixins: [UsersPermissionCheck],

  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["loading", "dictionaries"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"])
  },

  mounted() {
    const tempPaymentMethod = this.dictionaries.activity;
    this.payment_methods = tempPaymentMethod != null ? this.dictionaries.activity.global_payment_methods : '';
    this.getList();
    this.getAdditionalData();
  },

  data() {
    return {
      allDataObj: null,
      vatSortOrder: false,
      banks: [],
      cc_providers: [],
      cc_list: [],
      cc_types: [
        {
          id: 1,
          type: "business"
        },
        {
          id: 2,
          type: "business Personal"
        },
        {
          id: 3,
          type: "Private"
        }
      ],
      amountSortOrder: false,
      rangePaymentMethodData: [],
      showTotalMs: false,
      queryObject: {
        page: 1
      },
      payment_methods: [],
      categories: [],
      users: [
        {
          id: 56,
          name: "Guy"
        },
        {
          id: 41,
          name: "Mike"
        },
        {
          id: 22,
          name: "Roman"
        },
        {
          id: 42,
          name: "Itzik"
        },
        {
          id: 43,
          name: "Kiril"
        },
        {
          id: 107,
          name: "Eden"
        },
        {
          id: 127,
          name: "Viki"
        }
      ],
      statuses: [],
      pagination: {
        currentPage: 1,
        perPage: 7,
        from: 1,
        to: 1,
        lastPage: 1,
        total: 0
      },
      currency_types: [
        {
          id: 1,
          symbol: "$",
          name: "USD"
        },
        {
          id: 2,
          symbol: "€",
          name: "EUR"
        },
        {
          id: 3,
          symbol: "£",
          name: "GBP"
        },
        {
          id: 4,
          symbol: "₪",
          name: "ILS"
        }
      ],
      popUpId: null,
      creatorInfoPopup: null,
      totalUsers: 0,
      totalCategories: 0,
      totalAmount: 0,
      totalVat: 0,
      showFinance: true,
      selectedRows: [],
      selectAll: false,
      financeData: [],
      newRow: false,
      addNewCreditCard: false,
      creditCardList: false,
      mediaIsImage: false,
      mediaIsFile: false,
      showAttPopup: false,
      showCCInfo: null,
      filterByInvoiceNumber: "",
      filterByUserName: "",
      searchFilterByProject: "",
      searchFilterByCategory: "",
      searchFilterByType: "",
      searchFilterByReason: "",
      searchFilterByDetail: "",
      filterByAmount: "",
      filterByVat: "",
      paginationDropDownUp: true,

      reset: {
        category_id: 1,
        purchase_types: [],
        purchase_details: null,
        amount: null,
        currency_id: 4,
        purchase_reasons: [],
        purchase_method: [],
        purchase_date: null,
        invoice_date: null,
        invoice_number: null,
        attachment: ""
      },
      key: 1,

      user_id: null,
      editMode: false,
      editFinance: {
        purchase_reasons: [],
        purchase_types: [],
        projects: [],
        details: []
      },
      ccToEdit: {
        id: null,
        type: null,
        bank: null,
        provider: null,
        last_4_digits: null,
        due_date: null
      },
      editCcId: null,
      newCreditCard: {
        user_id: null,
        type: null,
        bank: null,
        provider: null,
        credit_line: null,
        due_date: null,
        last_4_digits: null
      },
      invoiceNumberExists: false,
      showTaxPercent: false,
      newFinance: {
        category_id: 1,
        purchase_types: [],
        purchase_details: null,
        amount: null,
        currency_id: 4,
        purchase_reasons: [],
        purchase_method: [],
        purchase_date: null,
        invoice_date: null,
        due_date: null,
        invoice_number: null,
        attachment: "",
        ref_id: null,
        status_id: null,
        projects: [],
        details: [],
        payments_period: null,
        with_vat: false,
        vat: null,
        taxPercent: null
      },
      fileReceived: false,
      prevPageNumInput: "",
      pageNumInput: 1,
      showVatCheckBox: false,
      showEditVatCheckBox: false,
      editWithVat: false,
      middleChartDate: []
    };
  },

  watch: {
    editWithVat: function() {
      if (this.editWithVat) {
        if (
          this.editFinance.amount !== "" &&
          this.editFinance.amount !== null
        ) {
          this.editFinance.vat = (this.editFinance.amount * 17) / 100;
        }
        if (
          this.editFinance.amount === "" ||
          this.editFinance.amount === null
        ) {
          this.editFinance.vat = null;
        }
      }
      if (!this.editWithVat) {
        this.editFinance.vat = null;
      }
    },
    "editFinance.vat": function() {
      if (this.editFinance.vat !== null) {
        this.editWithVat = true;
      }
    },
    "newFinance.invoice_number": function() {
      if (this.newFinance.invoice_number === "") {
        this.newFinance.invoice_number = null;
        this.invoiceNumberExists = false;
      }
      if (
        this.newFinance.invoice_number !== "" ||
        this.newFinance.invoice_number !== null
      ) {
        apiClientCreator("finance/check_invoice")
          .post("", {
            invoice: this.newFinance.invoice_number
          })
          .then(({ data }) => {
            if (data.length > 0) {
              this.invoiceNumberExists = true;
            }
            if (data.length < 1) {
              this.invoiceNumberExists = false;
            }
          });
      }
    },
    "newFinance.amount": function() {
      if (this.newFinance.amount !== null || this.newFinance.amount !== "") {
        this.showVatCheckBox = true;
      }
      if (this.newFinance.amount === "" || this.newFinance.amount === null) {
        this.showVatCheckBox = false;
        this.newFinance.with_vat = false;
        this.newFinance.vat = null;
      }
      if (
        this.newFinance.with_vat === true &&
        this.newFinance.amount !== "" &&
        this.newFinance.amount !== null
      ) {
        this.newFinance.vat = (this.newFinance.amount * 17) / 100;
      }
      if (this.newFinance.with_vat === false) {
        this.newFinance.vat = null;
      }
    },
    "newFinance.with_vat": function() {
      if (this.newFinance.with_vat === true) {
        this.newFinance.vat = Math.round((this.newFinance.amount * 17) / 100);
      }
      if (this.newFinance.with_vat === false) {
        this.newFinance.vat = null;
      }
    },
    "newFinance.category_id": function() {
      if (
        this.newFinance.category_id === 1 ||
        this.newFinance.category_id === 7
      ) {
        this.showTaxPercent = true;
      } else {
        this.showTaxPercent = false;
        this.newFinance.taxPercent = null;
      }
    },

    "editFinance.amount": function() {
      if (this.editWithVat) {
        if (
          this.editFinance.amount !== "" &&
          this.editFinance.amount !== null
        ) {
          this.editFinance.vat = (this.editFinance.amount * 17) / 100;
        }
        if (
          this.editFinance.amount === "" ||
          this.editFinance.amount === null
        ) {
          this.editFinance.vat = null;
        }
      }
    },

    "newFinance.ref_id": function() {
      if (
        (this.newFinance.ref_id === "1122" ||
          this.newFinance.ref_id === "3700") &&
        this.newFinance.purchase_method === "Credit Card "
      ) {
        this.newFinance.due_date = moment()
          .add(1, "M")
          .startOf("month")
          .add(1, "day")
          .format("YYYY-MM-DD");
      }
      if (
        this.newFinance.ref_id === "5878" &&
        this.newFinance.purchase_method === "Credit Card "
      ) {
        this.newFinance.due_date = moment()
          .add(1, "M")
          .startOf("month")
          .add(19, "day")
          .format("YYYY-MM-DD");
      }
    },
    "editFinance.ref_id": function() {
      if (
        (this.editFinance.ref_id === "1122" ||
          this.editFinance.ref_id === "3700") &&
        (this.editFinance.purchase_method === "Credit Card " ||
          this.editFinance.purchase_method === "Credit Card")
      ) {
        this.editFinance.due_date = moment()
          .add(1, "M")
          .startOf("month")
          .add(1, "day")
          .format("YYYY-MM-DD");
      }
      if (
        this.editFinance.ref_id === "5878" &&
        (this.editFinance.purchase_method === "Credit Card " ||
          this.editFinance.purchase_method === "Credit Card")
      ) {
        this.editFinance.due_date = moment()
          .add(1, "M")
          .startOf("month")
          .add(19, "day")
          .format("YYYY-MM-DD");
      }
    },

    "newFinance.purchase_method": function() {
      if (
        this.newFinance.purchase_method === "Cash" ||
        this.newFinance.purchase_method === "Wire Transfer"
      ) {
        this.newFinance.purchase_date = moment().format("YYYY-MM-DDThh:mm");
      }
    },
    "editFinance.purchase_method": function() {
      if (
        this.editFinance.purchase_method === "Cash" ||
        this.editFinance.purchase_method === "Wire Transfer"
      ) {
        this.editFinance.purchase_date = moment().format("YYYY-MM-DDThh:mm");
      }
    },

    showAttPopup() {
      if (this.showAttPopup === false) {
        this.mediaIsImage = false;
        this.mediaIsFile = false;
        this.fileReceived = false;
      }
    },
    user_id() {
      if (this.user_id !== null && !this.editMode) {
        this.newFinance.user_id = this.user_id;
      }
      if (this.user_id !== null && this.editMode) {
        this.editFinance.user_id = this.user_id;
      }
    },
    filterByInvoiceNumber() {
      this.queryObject.invoice_number_filter = this.filterByInvoiceNumber;
      if (this.filterByInvoiceNumber === "") {
        delete this.queryObject.invoice_number_filter;
      }
      this.getList();
    },
    filterByAmount() {
      this.queryObject.amount_filter = this.filterByAmount;
      if (this.filterByAmount === "") {
        delete this.queryObject.amount_filter;
      }
      this.getList();
    },
    filterByVat() {
      this.queryObject.vat_filter = this.filterByVat;
      if (this.filterByVat === "") {
        delete this.queryObject.vat_filter;
      }
      this.getList();
    },

    filterByUserName() {
      this.queryObject.user_name_filter = this.filterByUserName;
      if (this.filterByUserName === "") {
        delete this.queryObject.user_name_filter;
      }
      this.getList();
    },
    searchFilterByProject() {
      this.filterByProject(this.searchFilterByProject);
      if (this.searchFilterByProject === "") {
        delete this.queryObject.filter_projects;
      }
      //this.getList();
    },
    searchFilterByCategory() {
      this.queryObject.search_filter_category = this.searchFilterByCategory;
      if (this.searchFilterByCategory === "") {
        delete this.queryObject.search_filter_category;
      }
      this.getList();
    },
    searchFilterByType() {
      this.queryObject.search_filter_type = this.searchFilterByType;
      if (this.searchFilterByType === "") {
        delete this.queryObject.search_filter_type;
      }
      this.getList();
    },
    searchFilterByReason() {
      this.queryObject.search_filter_reason = this.searchFilterByReason;
      if (this.searchFilterByReason === "") {
        delete this.queryObject.search_filter_reason;
      }
      this.getList();
    },
    searchFilterByDetail() {
      this.queryObject.search_filter_details = this.searchFilterByDetail;
      if (this.searchFilterByDetail === "") {
        delete this.queryObject.search_filter_details;
      }
      this.getList();
    },
    selectAll() {
      if (this.selectAll) {
        let tempAll = [];
        this.financeData.forEach(row => {
          tempAll.push(row.id);
        });
        this.selectedRows = tempAll;
      }
      if (!this.selectAll) {
        this.selectedRows = [];
      }
    }
  },

  methods: {
    fillIt(x) {
      this.allDataObj = x.all;
    },
    getTotalAmount() {
      apiClientCreator("finance/get_total_sum")
        .get("", { params: this.queryObject })
        .then(res => {
          this.totalAmount = res.data;
        });
    },
    msCategories(categories) {
      let c = categories.map(i => i.id);
      this.queryObject.ms_categories = c;
      this.getList();
    },
    msMethods(methods) {
      let m = methods.map(i => i.id);
      this.queryObject.ms_methods = m;
      this.getList();
    },
    msCurrency(methods) {
      let cur = methods.map(i => i.id);
      this.queryObject.ms_currency = cur;
      this.getList();
    },
    msStatus(methods) {
      let s = methods.map(i => i.id);
      this.queryObject.ms_statuses = s;
      this.getList();
    },
    showAttachmentPopup(id, show) {
      if (show === true) {
        this.popUpId = id;
        this.showAttPopup = true;
      }
      if (show === false) {
        this.popUpId = null;
        this.showAttPopup = false;
      }
    },
    checkForPayments(finance) {
      if (
        finance.purchase_method === "Credit Card" &&
        finance.payments_period !== null
      ) {
        let t = finance.ils_amount;
        let p = finance.payments_period;
        return Math.round(t / p);
      }
      if (
        finance.purchase_method === "Credit Card" &&
        finance.payments_period === null
      ) {
        let t = finance.ils_amount;
        //let p = finance.payments_period;
        return Math.round(t / 1);
      } else {
        return "error";
      }
    },
    calcVatPayments(finance) {
      if (finance.vat !== null && finance.payments_period !== null) {
        let vat = Math.round(finance.vat / finance.payments_period);
        return (vat > 0) ? '+' + vat : vat;
      }
      if (finance.vat === null && finance.payments_period !== null) {
        // let v = (finance.ils_amount*17)/100
        // return Math.round(v/finance.payments_period)
        return 0;
      }
      if (finance.vat !== null && finance.payments_period === null) {
        let v = (finance.ils_amount * 17) / 100;
        let vat = Math.round(v);
        return (vat > 0) ? '+' + vat : vat;
      }
      if (finance.vat === null && finance.payments_period === null) {
        return 0;
      }
    },
    closeCreditCardListModel() {
      this.creditCardList = false;
      this.editCcId = null;
      this.ccToEdit = {
        id: null,
        type: null,
        bank: null,
        provider: null,
        last_4_digits: null,
        due_date: null
      };
    },
    setInitialTags(tag) {
      if (tag === "types") {
        return this.editFinance.purchase_types.map(i => i.value);
      }
      if (tag === "reasons") {
        return this.editFinance.purchase_reasons.map(i => i.value);
      }
      if (tag === "projects") {
        return this.editFinance.projects.map(i => i.value);
      }
      if (tag === "details") {
        return this.editFinance.details.map(i => i.value);
      }
    },
    updateKey(data) {
      this.key = data;
    },
    checkFileType() {
      let images = [
        "png",
        "jpg",
        "jpeg",
        "gif",
        "PNG",
        "JPG",
        "JPEG",
        "BMP",
        "bmp"
      ];
      let files = [
        "doc",
        "docx",
        "DOCX",
        "DOC",
        "XLS",
        "xls",
        "xlsx",
        "XLSX",
        "pdf",
        "PDF",
        "PPT",
        "ppt",
        "pptx",
        "PPTX"
      ];
      let type = this.editFinance.attachment
        .split(/[#?]/)[0]
        .split(".")
        .pop()
        .trim();
      if (images.includes(type)) {
        this.mediaIsFile = false;
        this.mediaIsImage = true;
        return "image";
        //return this.mediaIsImage
      }
      if (files.includes(type)) {
        this.mediaIsFile = true;
        this.mediaIsImage = false;
        return "file";
        //return this.mediaIsFile;
      } else {
        return false;
      }
    },
    checkAttachmentType(attachment) {
      if (attachment !== "") {
        let images = [
          "png",
          "jpg",
          "jpeg",
          "gif",
          "PNG",
          "JPG",
          "JPEG",
          "BMP",
          "bmp"
        ];
        let files = [
          "doc",
          "docx",
          "DOCX",
          "DOC",
          "XLS",
          "xls",
          "xlsx",
          "XLSX",
          "pdf",
          "PDF",
          "PPT",
          "ppt",
          "pptx",
          "PPTX"
        ];
        let type = attachment
          .split(/[#?]/)[0]
          .split(".")
          .pop()
          .trim();
        if (images.includes(type)) {
          this.mediaIsFile = false;
          this.mediaIsImage = true;
          return "image";
        }
        if (files.includes(type)) {
          this.mediaIsImage = false;
          this.mediaIsFile = true;
          return "file";
        }
      }
      if (attachment === "") {
        return false;
      }
    },
    updateFinance(id) {
      let updateFinance = apiClientCreator(`finance/edit_row/${id}`);
      updateFinance
        .post("", {
          finance: this.editFinance
        })
        .then(result => {
          this.editMode = false;
          this.mediaIsImage = false;
          this.mediaIsFile = false;
          this.fileReceived = false;
          this.editWithVat = false;
          this.showEditVatCheckBox = false;
          this.editFinance = {
            purchase_reasons: [],
            purchase_method: [],
            projects: [],
            details: []
          };
          this.selectedRows = [];
          this.getList();
        });
    },
    cancelEditRow() {
      this.mediaIsImage = false;
      this.mediaIsFile = false;
      this.fileReceived = false;
      this.editMode = false;
      this.editWithVat = false;
      this.showEditVatCheckBox = false;
      this.editFinance = {
        purchase_reasons: [],
        purchase_method: [],
        projects: [],
        details: []
      };
    },
    filterByReason(reason) {
      this.queryObject.filter_reason = reason;
      this.getList();
    },
    filterByDetails(detail) {
      this.queryObject.filter_details = detail;
      this.getList();
    },
    filterByProject(project) {
      this.queryObject.filter_projects = project;
      this.getList();
    },
    filterByType(type) {
      this.queryObject.filter_type = type;
      this.getList();
    },
    clearDates() {
      delete this.queryObject.purchase_from;
      delete this.queryObject.purchase_to;
      this.getList();
    },
    setPaymentMethodsInfo(data) {
      this.rangePaymentMethodData = data;
    },

    setDate(data) {
      this.queryObject = {};
      this.queryObject = Object.assign({}, this.queryObject, {
        purchase_from: moment(data.date.start).format("YYYY-MM-DD"),
        purchase_to: moment(data.date.end).format("YYYY-MM-DD")
      });
      this.getList();
    },
    setTotalSpentDate(data) {
      this.queryObject = {};
      this.queryObject = Object.assign({}, this.queryObject, {
        total_spent_from: moment(data.date.start).format("YYYY-MM-DD"),
        total_spent_to: moment(data.date.end).format("YYYY-MM-DD")
      });
      this.getList();
    },
    setInvoiceDate(data) {
      this.queryObject = {};
      this.queryObject = Object.assign({}, this.queryObject, {
        invoice_from: moment(data.date.start).format("YYYY-MM-DD"),
        invoice_to: moment(data.date.end).format("YYYY-MM-DD")
      });
      this.getList();
    },
    setCreatedDate(data) {
      this.queryObject = {};
      this.queryObject = Object.assign({}, this.queryObject, {
        created_at_from: moment(data.date.start).format("YYYY-MM-DD"),
        created_at_to: moment(data.date.end).format("YYYY-MM-DD")
      });
      this.getList();
    },

    setDueDate(data) {
      this.queryObject = {};
      this.queryObject = Object.assign({}, this.queryObject, {
        due_date_from: moment(data.date.start).format("YYYY-MM-DD"),
        due_date_at: moment(data.date.end).format("YYYY-MM-DD")
      });
      this.getList();
    },
    calcAmount(finance) {
      let inIls;
      if (finance.currency_id === 2) {
        inIls = finance.amount * 3.96;
      }
      if (finance.currency_id === 1) {
        inIls = finance.amount * 3.25;
      }
      if (finance.currency_id === 3) {
        inIls = finance.amount * 4.34;
      }
      if (finance.currency_id === 4) {
        inIls = finance.amount;
      }
      return new Intl.NumberFormat("he-IL", {}).format(inIls);
    },
    displayOriginalAmount(finance) {
      let am = finance.amount;
      let type;
      if (finance.currency_id === 2) {
        type = "EUR";
      }
      if (finance.currency_id === 1) {
        type = "USD";
      }
      if (finance.currency_id === 3) {
        type = "GBP";
      }
      if (finance.currency_id === 4) {
        type = "ILS";
      }
      return new Intl.NumberFormat("he-IL", {
        style: "currency",
        currency: type
      }).format(am);
    },
    filterByCurrency(currency) {
      this.queryObject.currency_filter = currency;
      this.getList();
    },
    filterByStatus(status) {
      this.queryObject.status = status;
      this.getList();
    },
    filterByPaymentMethod(method) {
      this.queryObject.purchase_method = method;
      this.getList();
    },
    filterByLastDigits(ref_id) {
      this.queryObject.ref_id = ref_id;
      this.getList();
    },
    kFormatter(num) {
      if (num !== 0) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
      return "";
    },
    sortByAmount() {
      delete this.queryObject.amount_order_asc;
      this.amountSortOrder = true;
      this.queryObject.amount_order_desc = true;
      this.getList();
    },
    sortByAmountAsc() {
      delete this.queryObject.amount_order_desc;
      this.amountSortOrder = false;
      this.queryObject.amount_order_asc = true;
      this.getList();
    },
    sortByVat() {
      delete this.queryObject.vat_order_asc;
      this.vatSortOrder = true;
      this.queryObject.vat_order_desc = true;
      this.getList();
    },
    sortByVatAsc() {
      delete this.queryObject.vat_order_desc;
      this.vatSortOrder = false;
      this.queryObject.vat_order_asc = true;
      this.getList();
    },

    filterByMainCategory(category) {
      this.showTotalMs = true;
      this.queryObject.category = category;
      this.getList();
    },
    formatDate(date, withHours = true) {
      if (withHours) {
        return moment(String(date)).format("DD/MM/YY HH:mm");
      }
      if (!withHours) {
        return moment(String(date)).format("DD/MM/YY");
      }
    },
    // formatDueDate(date) {
    //   return moment(String(date)).format("DD/MM/YY");
    // },
    setPage(pageNum) {
      this.pagination.currentPage = pageNum;
      this.queryObject.page = pageNum;
      this.getList();
      this.pageNumInput = "";
    },
    async getAdditionalData() {
      let getCategoriesList = apiClientCreator("finance/categories");
      let cresult = await getCategoriesList.get("");
      this.categories = cresult.data;

      let getStatusList = apiClientCreator("finance/get_statuses");
      let sresult = await getStatusList.get("");
      this.statuses = sresult.data;

      let getBanksList = apiClientCreator("finance/get_banks");
      let bresult = await getBanksList.get("");
      this.banks = bresult.data;

      let getCcProvidersList = apiClientCreator("finance/get_cc_providers");
      let cpresult = await getCcProvidersList.get("");
      this.cc_providers = cpresult.data;

      let getAllCcList = apiClientCreator("finance/get_all_cc");
      let acresult = await getAllCcList.get("");
      this.cc_list = acresult.data;
    },
    async getCategories() {
      let getCategoriesList = apiClientCreator("finance/categories");
      let result = await getCategoriesList.get("");
      this.categories = result.data;
    },
    async getStatuses() {
      let getStatusList = apiClientCreator("finance/get_statuses");
      let result = await getStatusList.get("");
      this.statuses = result.data;
    },
    async getBanks() {
      let getBanksList = apiClientCreator("finance/get_banks");
      let result = await getBanksList.get("");
      this.banks = result.data;
    },
    async getCcProviders() {
      let getCcProvidersList = apiClientCreator("finance/get_cc_providers");
      let result = await getCcProvidersList.get("");
      this.cc_providers = result.data;
    },
    async getAllCc() {
      let getAllCcList = apiClientCreator("finance/get_all_cc");
      let result = await getAllCcList.get("");
      this.cc_list = result.data;
    },
    removeFile() {
      this.newFinance.attachment = "";
      this.mediaIsImage = false;
      this.mediaIsFile = false;
      this.fileReceived = false;
    },
    removeFileFromEdit() {
      this.editFinance.attachment = "";
      this.mediaIsImage = false;
      this.mediaIsFile = false;
    },
    uploadFile() {
      this.fileReceived = true;
      if ($("input[type=file]")[0].files[0]["type"].split("/")[0] === "image") {
        this.mediaIsImage = true;
        this.mediaIsFile = false;
      } else {
        this.mediaIsFile = true;
        this.mediaIsImage = false;
      }

      let formData = new FormData();
      formData.append("attachment", $("input[type=file]")[0].files[0]);
      apiClientCreator(`finance/add_file`)
        .post("", formData)
        .then(result => {
          if (!this.editMode) {
            this.newFinance.attachment = result.data;
          }
          if (this.editMode) {
            this.editFinance.attachment = result.data;
          }
        });
    },
    getCurrency(currency) {
      let cur = this.currency_types.find(t => t.id === currency);
      return `${cur.symbol}`;
    },
    dataFromGraphChart(data) {
      let labels = [];
      let Count = [];
      let chartData = this.retChartData;
      let opt = chartData.options;
      let chartId = "finance-stats-main-chart";
      this.rangePaymentMethodData.forEach(r => {
        if (
          r.method === "T.Expenses" &&
          r.method === "T.Income" &&
          r.method === "T.Sum"
        ) {
          labels.push(r.method);
          Count.push(r.count);
        }
        this.middleChartDate = [labels, Count];
      });
    },
    handleTags(tags) {
      if (tags[1] === "types") {
        this.newFinance.purchase_types = [];
        tags[0].forEach(t => {
          this.newFinance.purchase_types.push(t);
        });
      }
      if (tags[1] === "reasons") {
        this.newFinance.purchase_reasons = [];
        tags[0].forEach(t => {
          this.newFinance.purchase_reasons.push(t);
        });
      }
      if (tags[1] === "projects") {
        this.newFinance.projects = [];
        tags[0].forEach(t => {
          this.newFinance.projects.push(t);
        });
      }
      if (tags[1] === "details") {
        this.newFinance.details = [];
        tags[0].forEach(t => {
          this.newFinance.details.push(t);
        });
      }
      if (tags[1] === "method") {
        this.newFinance.purchase_method = tags[0];
      }
    },

    updateTags(tags) {
      if (tags[1] === "types") {
        this.editFinance.purchase_types = [];
        this.editFinance.purchase_types = tags[0];
      }
      if (tags[1] === "reasons") {
        this.editFinance.purchase_reasons = [];
        this.editFinance.purchase_reasons = tags[0];
      }
      if (tags[1] === "projects") {
        this.editFinance.projects = [];
        this.editFinance.projects = tags[0];
      }
      if (tags[1] === "details") {
        this.editFinance.details = [];
        this.editFinance.details = tags[0];
      }
      if (tags[1] === "method") {
        this.editFinance.purchase_method = tags[0];
      }
    },
    async getList() {
      this.$store.commit("clients/setLoading", true);

      let getFinanceList = apiClientCreator("finance/list");
      let result = await getFinanceList.get("", { params: this.queryObject });
      this.pagination.currentPage = result.data.current_page;
      this.pagination.perPage = result.data.per_page;
      this.pagination.total = result.data.total;
      this.pagination.lastPage = result.data.last_page;
      this.pagination.to = result.data.to;
      this.pagination.from = result.data.from;

      let financeData = [];
      result.data.data.forEach(finance => {
        financeData.push(new FinanceModel(finance));
      });
      this.financeData = financeData;
      this.calcTotals(result.data.data);
      this.getTotalAmount();
      this.$store.commit("clients/setLoading", false);
    },

    calcTotals(data) {
      let allUsers = data.map(p => p.user_id);
      this.totalUsers = [...new Set(allUsers)].length;
      let allCategories = data.map(p => p.category_id);
      this.totalCategories = [...new Set(allCategories)].length;

      // let tempAmount = [];
      // data.map(p => {
      //   let inIls;
      //   if (p.currency_id === 2) {
      //     inIls = p.amount * 3.96;
      //   }
      //   if (p.currency_id === 1) {
      //     inIls = p.amount * 3.25;
      //   }
      //   if (p.currency_id === 3) {
      //     inIls = p.amount * 4.34;
      //   }
      //   if (p.currency_id === 4) {
      //     inIls = p.amount;
      //   }
      //   tempAmount.push(inIls);
      // });
      // let total = 0;
      // for (let i = 0; i < tempAmount.length; i++) {
      //   total = total += tempAmount[i];
      // }
      // this.totalAmount = total;

      let tempVat = [];

      data.map(v => {
        if (v.vat !== null) {
          tempVat.push(v.vat);
        }
      });

      let tv = 0;
      for (let i = 0; i < tempVat.length; i++) {
        tv = tv += tempVat[i];
      }
      this.totalVat = tv;
    },
    currencyFilterActive() {
      return this.queryObject.hasOwnProperty("currency_filter");
    },
    statusFilterActive() {
      return this.queryObject.hasOwnProperty("status");
    },
    refIdFilterActive() {
      return this.queryObject.hasOwnProperty("ref_id");
    },
    reasonFilterActive() {
      return this.queryObject.hasOwnProperty("filter_reason");
    },
    detailsFilterActive() {
      return this.queryObject.hasOwnProperty("filter_details");
    },
    typeFilterActive() {
      return this.queryObject.hasOwnProperty("filter_type");
    },
    amountFilterActive() {
      return (
        this.queryObject.hasOwnProperty("amount_filter") ||
        this.queryObject.hasOwnProperty("amount_order_asc") ||
        this.queryObject.hasOwnProperty("amount_order_desc")
      );
    },
    vatFilterActive() {
      return (
        this.queryObject.hasOwnProperty("vat_filter") ||
        this.queryObject.hasOwnProperty("vat_order_asc") ||
        this.queryObject.hasOwnProperty("vat_order_desc")
      );
    },
    invoiceNumberFilterActive() {
      return this.queryObject.hasOwnProperty("invoice_number_filter");
    },
    projectFilterActive() {
      return this.queryObject.hasOwnProperty("filter_projects");
    },
    invoiceDateFilterActive() {
      return this.queryObject.hasOwnProperty("invoice_from");
    },
    dueDateFilterActive() {
      return this.queryObject.hasOwnProperty("due_date_from");
    },
    purchaseDateFilterActive() {
      return this.queryObject.hasOwnProperty("purchase_from");
    },
    methodFilterActive() {
      return this.queryObject.hasOwnProperty("purchase_method");
    },
    categoryFilterActive() {
      return this.queryObject.hasOwnProperty("category");
    },
    removeTypeFilter() {
      delete this.queryObject.filter_type;
      this.getList();
    },
    removeReasonFilter() {
      delete this.queryObject.filter_reason;
      this.getList();
    },
    removeDetailsFilter() {
      delete this.queryObject.filter_details;
      this.getList();
    },
    removeMethodFilter() {
      delete this.queryObject.purchase_method;
      this.getList();
    },
    removeRefIdFilter() {
      delete this.queryObject.ref_id;
      this.getList();
    },
    removeInvoiceDateFilter() {
      delete this.queryObject.invoice_from;
      delete this.queryObject.invoice_to;
      this.getList();
    },
    removeDueDateFilter() {
      delete this.queryObject.due_date_from;
      delete this.queryObject.due_date_at;
      this.getList();
    },
    removePurchaseDateFilter() {
      delete this.queryObject.purchase_from;
      delete this.queryObject.purchase_to;
      this.getList();
    },
    removeInvoiceNumberFilter() {
      delete this.queryObject.invoice_number_filter;
      this.getList();
    },
    removeProjectFilter() {
      this.searchFilterByProject = "";
      delete this.queryObject.filter_projects;
      this.getList();
    },

    removeCurrencyFilter() {
      delete this.queryObject.currency_filter;
      this.getList();
    },
    removeStatusFilter() {
      delete this.queryObject.status;
      this.getList();
    },
    removeAmountFilter() {
      this.filterByAmount = "";
      delete this.queryObject.amount_filter;
      delete this.queryObject.amount_order_asc;
      delete this.queryObject.amount_order_desc;
      this.getList();
    },
    removeVatFilter() {
      this.filterByVat = "";
      delete this.queryObject.vat_filter;
      this.getList();
    },

    removeCategoryFilter() {
      this.showTotalMs = false;
      delete this.queryObject.category;
      this.getList();
    },
    rowSelected(id) {
      return this.selectedRows.some(t => t === id);
    },

    deleteRow(id = 0, bulk = false) {
      if (bulk === false) {
        if (confirm("Are you sure you want to delete this?")) {
          apiClientCreator(`finance/delete_row/${id}`)
            .post("")
            .then(result => {
              this.$store.commit("main/setShowVikiMsg", {
                show: true,
                msg: "Row deleted",
                type: "DONE",
                op: { type: "" },
                op_code: null,
                updatedAt: null
              });
              this.editMode = false;
              this.selectedRows = [];
              this.getList();
            });
        }
      }

      if (id === 0 && bulk === true) {
        if (confirm("Are you sure you want to delete this?")) {
          this.selectedRows.forEach(r => {
            apiClientCreator(`finance/delete_row/${r}`)
              .post("")
              .then(result => {
                this.selectedRows = [];
                this.selectAll = false;
                this.getList();

                this.$store.commit("main/setShowVikiMsg", {
                  show: true,
                  msg: "Row deleted",
                  type: "DONE",
                  op: { type: "" },
                  op_code: null,
                  updatedAt: null
                });
              });
          });
        }
      }
    },

    deleteCreditCard(id = 0, bulk = false) {
      if (bulk === false) {
        if (confirm("Are you sure you want to delete this credit card?")) {
          apiClientCreator(`finance/delete_credit_card/${id}`)
            .post("")
            .then(result => {
              this.$store.commit("main/setShowVikiMsg", {
                show: true,
                msg: "CC Deleted",
                type: "DONE",
                op: { type: "" },
                op_code: null,
                updatedAt: null
              });
              this.getAllCc();
            });
        }
      }

      if (id === 0 && bulk === true) {
        if (confirm("Are you sure you want to delete this?")) {
          this.selectedRows.forEach(r => {
            apiClientCreator(`finance/delete_row/${r}`)
              .post("")
              .then(result => {
                this.$store.commit("main/setShowVikiMsg", {
                  show: true,
                  msg: "Row deleted",
                  type: "DONE",
                  op: { type: "" },
                  op_code: null,
                  updatedAt: null
                });
              });
          });
          this.selectedRows = [];
          this.selectAll = false;
          this.getList();
        }
      }
    },
    checkArray(array, tag) {
      if (tag === "types") {
        let t = [];
        array.forEach(i => {
          t.push({ value: i.type });
        });
        return t;
      }
      if (tag === "reasons") {
        let r = [];
        array.forEach(i => {
          r.push({ value: i.reason });
        });
        return r;
      }

      if (tag === "projects") {
        let p = [];
        array.forEach(i => {
          p.push({ value: i.project });
        });
        return p;
      }
      if (tag === "details") {
        let d = [];
        array.forEach(i => {
          d.push({ value: i.detail });
        });
        return d;
      }
    },

    editRow(finance) {
      this.showEditVatCheckBox = true;
      this.editFinance = {
        id: finance.id,
        user_id: finance.user_id,
        category_id: finance.category.id,
        purchase_types: this.checkArray(finance.types, "types"),
        purchase_details: finance.purchase_details,
        amount: finance.amount,
        currency_id: finance.currency_id,
        purchase_reasons: this.checkArray(finance.reasons, "reasons"),
        purchase_method: finance.purchase_method,
        purchase_date: moment(finance.purchase_date).format("YYYY-MM-DDThh:mm"),
        invoice_date: moment(finance.invoice_date).format("YYYY-MM-DD"),
        due_date: moment(finance.due_date).format("YYYY-MM-DD"),
        invoice_number: finance.invoice_number,
        attachment: finance.attachment,
        ref_id: finance.ref_id,
        status_id: finance.status_id,
        projects: this.checkArray(finance.projects, "projects"),
        details: this.checkArray(finance.details, "details"),
        payments_period: finance.payments_period,
        is_weekly_period: finance.is_weekly_period,
        vat: finance.vat,
        with_vat: finance.vat !== null,
        withholding_tax: finance.withholding_tax,
        taxPercent: null
      };
      this.editMode = true;
    },
    editCreditCard(card) {
      this.editCcId = card.id;
      this.ccToEdit = {
        id: card.id,
        user_id: card.user_id,
        type: card.type,
        bank: card.bank,
        provider: card.provider,
        last_4_digits: card.last_4_digits,
        due_date: moment(card.due_date).format("YYYY-MM-DDThh:mm")
      };
    },

    addRow() {
      this.mediaIsFile = false;
      this.showAttPopup = false;
      this.mediaIsImage = false;
      this.newRow = true;
    },
    addNewCC() {
      this.addNewCreditCard = true;
    },
    showCreditCardList() {
      this.creditCardList = true;
    },

    cancelAddRow() {
      this.newRow = false;
      this.newFinance.category_id = 1;
      this.newFinance.purchase_types = [];
      this.newFinance.purchase_details = null;
      this.newFinance.amount = null;
      this.newFinance.currency_id = 4;
      this.newFinance.purchase_reasons = [];
      this.newFinance.projects = [];
      this.newFinance.purchase_method = [];
      this.newFinance.details = [];
      this.newFinance.purchase_date = null;
      this.newFinance.invoice_date = null;
      this.newFinance.invoice_number = null;
      this.newFinance.attachment = "";
      this.mediaIsFile = false;
      this.mediaIsImage = false;
      this.fileReceived = false;
      this.newFinance.ref_id = null;
      this.newFinance.status_id = null;
      this.newFinance.payments_period = null;
      this.newFinance.with_vat = false;
      this.newFinance.vat = null;
      this.newFinance.due_date = null;
      this.newFinance.taxPercent = null;
    },
    cancelAddCc() {
      this.addNewCreditCard = false;
      this.newCreditCard = {
        user_id: null,
        type: null,
        bank: null,
        provider: null,
        credit_line: null,
        due_date: null,
        last_4_digits: null
      };
    },
    cancelShowCreditCardList() {
      this.creditCardList = false;
    },

    resetTable() {
      this.queryObject = { page: 1 };
      this.filterByUserName = "";
      this.filterByInvoiceNumber = "";
      this.filterByAmount = "";
      this.fileReceived = false;
      this.mediaIsFile = false;
      this.mediaIsImage = false;
      this.getList();
    },
    handlePDate(d) {
      this.newFinance.purchase_date = moment(d.target.value).format(
        "YYYY-MM-DDThh:mm"
      );
    },
    handleDueDate(d) {
      this.newCreditCard.due_date = moment(d.target.value).format("YYYY-MM-DD");
    },

    handleEPDate(d) {
      if (d.target.id === "edit_invoice_date") {
        this.editFinance.invoice_date = moment(d.target.value).format(
          "YYYY-MM-DD"
        );
      }
      if (d.target.id === "edit_purchase_date") {
        this.editFinance.purchase_date = moment(d.target.value).format(
          "YYYY-MM-DDThh:mm"
        );
      }
    },
    handleEDDate(d) {
      if (d.target.id === "edit_due_date") {
        this.editFinance.due_date = moment(d.target.value).format("YYYY-MM-DD");
      }
    },

    getMaxDate() {
      return new Date().toISOString().split("T")[0];
    },

    async saveNewFinance() {
      this.queryObject = { page: 1 };
      let createFinance = apiClientCreator("finance/create_finance");
      await createFinance.post("", {
        finance: this.newFinance
      });
      await this.getList();
      await this.getCategories();
      this.cancelAddRow();
    },
    async saveNewCreditCard() {
      this.queryObject = { page: 1 };
      let createCc = apiClientCreator("finance/create_credit_card");
      await createCc.post("", {
        card: this.newCreditCard
      });
      this.addNewCreditCard = false;
      this.newCreditCard = {
        type: null,
        bank: null,
        provider: null,
        credit_line: null,
        due_date: null,
        last_4_digits: null
      };
      await this.getAllCc();
    }
  }
};
</script>

<style scoped>
.main-finance-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.tag-item {
  padding: 3px 3px;
  margin: 2px;
  font-size: 12px;
}

.new-row {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

input[type="radio"] {
  margin: 3px 5px 0;
}

th {
  text-align: center;
}

.styleRow {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.form-control {
  border: 1px none #333;
  border-bottom-style: solid;
  display: block;
  width: 100%;
  height: 32px;
  padding: 0;
  margin-bottom: 15px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
}

.vertical-scroll-buttons {
  transition: all 0.3s ease-in-out;
  color: #988d23;
  display: flex;
  position: absolute;
  left: 857px;
}

.vertical-scroll-btn-first,
.vertical-scroll-btn-fourth {
  flex: 1;
  outline: none;
  border: none;
  margin-right: 2px;
}

.vertical-scroll-btn-second,
.vertical-scroll-btn-third {
  flex: 4;
  width: 52px;
  border: none;
  outline: none;
  font-size: 11.5px;
}

.vertical-scroll-btn-first {
  border-radius: 10px 0px 0px 10px;
  border-bottom: none;
}

.vertical-scroll-btn-fourth {
  border-radius: 0px 10px 10px 0px;
  border-top: none;
}

.vertical-scroll-buttons button:focus {
  background: #808080;
  color: #cbc26f;
}

.vertical-scroll-buttons button {
  background: #808080;
  color: #cbc26f;
}

.vertical-scroll-buttons button span {
  font-weight: 500;
}

.vertical-scroll-buttons button:hover {
  background: #716f6f;
  color: #cbc26f;
}

.vertical-scroll-buttons p {
  font-size: 14px;
  font-weight: bold;
}

.vertical-scroll-btn-menu:hover {
  background: #efefef;
  color: #cbc26f;
}

.vertical-scroll-btn-menu {
  border-radius: 0px 0px 0px 0px;
  background: #efefef;
  color: #cbc26f;
  border: none;
  outline: none;
}

.vertical-scroll-btn-menu {
  border: none;
  outline: none;
  width: 30px;
}

.vertical-scroll-buttons button[disabled] {
  background: #808080;
  opacity: 0.7;
  cursor: not-allowed;
}

.pagination-vertical-dropdown {
  top: 29px;
  left: 15px;
  border-radius: 5px;
  color: #988d23;
}

.open > .dropdown-menu {
  display: flex;
  flex-direction: column;
}

.tempLikeViki {
  min-width: calc(10%);
  max-width: calc(10%);
  margin-bottom: 30px;
  max-height: 100%;
}

.input-filter-invoice-number {
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border: 1px solid transparent;
  height: 20px;
  width: 100%;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
  text-transform: capitalize;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  background: #f5f7ff;
  border-radius: 5px;
  min-width: 100%;
}
.input-filter-user-name {
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border: 1px solid transparent;
  height: 20px;
  width: 100%;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  background: #f5f7ff;
  border-radius: 5px;
  min-width: 61%;
}
.input-filter-category {
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border: 1px solid transparent;
  height: 20px;
  width: 100%;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  background: #f5f7ff;
  border-radius: 5px;
  min-width: 61%;
}

.input-filter-amount {
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border: 1px solid transparent;
  height: 20px;
  max-width: 55px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 10px;
  text-transform: capitalize;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  background: #f5f7ff;
  border-radius: 5px;
  /*min-width: 81%;*/
}

.modal-content {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  margin-top: 0;
}

label {
  display: block;
}

.modal-dialog {
  width: 950px;
  margin: 0 auto;
  height: 900px;
}

.reset-single-filter {
  position: relative;
  bottom: 6px;
  right: 2px;
  cursor: pointer;
  color: red;
}

.btn {
  display: inline-block;
  margin-bottom: 0;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

.files input {
  -webkit-transition: outline-offset 0.15s ease-in-out,
    background-color 0.15s linear;
  transition: outline-offset 0.15s ease-in-out, background-color 0.15s linear;
  text-align: center !important;
  margin: 0;
  width: 100% !important;
  height: 100%;
}

.files input:focus {
  -webkit-transition: outline-offset 0.15s ease-in-out,
    background-color 0.15s linear;
  transition: outline-offset 0.15s ease-in-out, background-color 0.15s linear;
  border: 1px solid #92b0b3;
}

.files {
  position: relative;
  outline: 2px dashed #92b0b3;
  outline-offset: -10px;
  height: 100%;
}

.files:after {
  pointer-events: none;
  position: absolute;
  top: 325px;
  left: 0;
  width: 80px;
  right: 0;
  height: 80px;
  content: "";
  background-image: url(https://www.flaticon.com/svg/static/icons/svg/126/126477.svg);
  display: block;
  margin: 0 auto;
  background-size: 100%;
  background-repeat: no-repeat;
}

.color input {
  background-color: #f1f1f1;
}

.files:before {
  position: absolute;
  bottom: 308px;
  content: "CLICK OR DRAG & DROP";
  left: 0;
  pointer-events: none;
  width: 100%;
  right: 0;
  height: 57px;
  display: block;
  margin: 0 auto;
  color: #2ea591;
  font-weight: 600;
  text-transform: capitalize;
  text-align: center;
}

.modal-body {
  position: relative;
  padding: 0;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 3px 5px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  margin-right: 3px;
}
.color-me-orange {
  background-color: #d58512 !important;
}
.color-me-red {
  background-color: #d9534f !important;
}
label {
  font-size: 13px;
}
.log-table-views {
  position: absolute;
  right: 3px;
  z-index: 10000;
  width: max-content;
  background-color: #fff;
  border-radius: 5px;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: "Montserrat" !important;
  font-size: 12px;
}
th {
  font-size: 13px;
  font-weight: 700;
}
::-webkit-input-placeholder {
  color: black;
}
</style>
